<template>
  <span>
  <p>Inhalt der Leistung:</p>

  <ul>
    <li>
      <p>Ausarbeitung eines Blitzschutzsystems mithilfe des 3d-Blitzkugelverfahren</p>

      <ul>
        <li>
          <p>Positionierung der Fangeinrichtungen</p>
        </li>
        <li>
          <p>Schutzraumerstellung</p>
        </li>
      </ul>
    </li>
    <li>
      <p>Erstellung von Details</p>
    </li>
    <li>
      <p>Berechnung der Trennungsabstände</p>
    </li>
    <li>
      <p>Textliche Beschreibung der Ma&szlig;nahmen</p>
    </li>
    <li>
      <p>Materialst&uuml;ckliste (LV)</p>
    </li>
  </ul>

  <p>
    Für die Konzepterstellung benötigen wir eine 3d-Modell. Sollte kein verwendbares Modell
    vorhanden sein, können wir dieses gerne für Sie erstellen. (zusätzliche Kosten)
  </p>

  <p><span style="font-size:9pt"><em>Optional: Erstellung eines 3d-Modelles mithilfe der Leistungen &bdquo;Zeichnungserstellung&ldquo; oder &bdquo;Laserscanning&ldquo;.<br/>
(sollten keine ausreichenden Unterlagen vorhanden sein)</em></span></p>

  <p><span style="font-size:9pt"><em>Optional: Bei einer unbekannten Blitzschutzklasse kann eine Risikoanalyse von unserer Seite durchgef&uuml;hrt werden.</em></span>
  </p>

  <p><span style="font-size:9pt"><em>Optional: Nach der Fertigstellung des Konzeptes k&ouml;nnen wir Ihnen gerne das Konzept pers&ouml;nlich vorstellen<br/>
(Planungsabschlussgespr&auml;ch)</em></span></p>
    </span>
</template>

<script>
export default {
  name: "TooltipBlitzschutzkonzept"
}
</script>

<style scoped>

</style>
